import { render, staticRenderFns } from "./DoubleArrowIcon.vue?vue&type=template&id=68b21561&"
import script from "./DoubleArrowIcon.vue?vue&type=script&lang=js&"
export * from "./DoubleArrowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports